export type IntegrationStatuses = {
  enableJustEatIntegration: { active: boolean },
  enableDeliverooIntegration: { active: boolean },
  enableUberEatsIntegration: { active: boolean },
  isUltraOrder: { active: boolean }
}